module.exports = __webpack_public_path__ + "img/align-right.11e4ecfb.svg";